<template>
  <el-dialog
    title="导出物流单"
    :visible.sync="visible"
    width="480px"
    append-to-body
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      v-loading="loading"
      :model="ruleForm"
      label-width="90px">
      <el-form-item
        label="物流模板:"
        prop="expressCode">
        <ent-logistics-select
          v-model="ruleForm.expressCode"
          :option="{vendorId: userInfo.orgId}" />
      </el-form-item>
      <el-form-item label="创建时间:">
        <el-date-picker
          v-model="ruleForm.createTime"
          style="width: 100%"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">关闭</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="downloadOrders">导出</el-button>
    </div>
  </el-dialog>
</template>
<script>
import EntLogisticsSelect from '../../components/business/ent-logistics-select.vue'
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  name: 'ExportExpressModal',
  components: { EntLogisticsSelect },
  props: {
    callback: Function
  },
  data() {
    return {
      visible: false,
      loading: false,
      ruleForm: {
        expressCode: null,
        createTime: null
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.ruleForm.expressCode = null
      this.ruleForm.createTime = null
    },
    downloadOrders() {
      this.loading = true
      const { expressCode, createTime } = this.ruleForm
      const [start, end] = createTime || [null, null]
      this.$store.dispatch('outstock/downloadcouriers', {
        payload: {
          expressCode,
          createTimeStart: +moment(start).startOf('days'),
          createTimeEnd: +moment(end).endOf('days')
        },
        success: () => {
          this.loading = false
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
